"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FOLDER_BY_PARENT_CUTOFF = exports.FOLDER_SEARCH_REQUEST_LIMIT = exports.FOLDER_BY_PARENT_REQUEST_LIMIT = void 0;
var FOLDER_BY_PARENT_REQUEST_LIMIT = 1000;
exports.FOLDER_BY_PARENT_REQUEST_LIMIT = FOLDER_BY_PARENT_REQUEST_LIMIT;
var FOLDER_SEARCH_REQUEST_LIMIT = 1000;
exports.FOLDER_SEARCH_REQUEST_LIMIT = FOLDER_SEARCH_REQUEST_LIMIT;
var FOLDER_BY_PARENT_CUTOFF = 2000;
exports.FOLDER_BY_PARENT_CUTOFF = FOLDER_BY_PARENT_CUTOFF;